import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { MessageCircle, Download, Tv, Settings, LogOut, Home as HomeIcon } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import Logo from './Logo';

const nav = [
  { to: '/home', label: 'Home', icon: HomeIcon },
  { to: '/chat', label: 'Assistenza', icon: MessageCircle },
  { to: '/guida', label: 'Guida', icon: Download },
  { to: '/apps', label: 'App', icon: Tv },
  { to: '/impostazioni', label: 'Impostazioni', icon: Settings },
];

export default function Layout({ children, title, right, showBack = false, backTo = '/home' }) {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  return (
    <div className="min-h-screen flex flex-col safe-top">
      <header className="sticky top-0 z-40 glass px-4 py-3 flex items-center gap-3">
        {showBack ? (
          <button data-testid="back-btn" onClick={() => navigate(backTo)} className="text-white/70 hover:text-[var(--gold)] transition-colors px-1">
            ←
          </button>
        ) : (
          <Logo size={32} />
        )}
        <h1 className="font-heading text-lg font-medium flex-1 truncate" data-testid="page-title">
          {title || 'Golden TV'}
        </h1>
        {right}
        {user && (
          <button data-testid="logout-btn" onClick={logout} className="p-2 text-white/50 hover:text-[var(--gold)] transition-colors">
            <LogOut className="w-4 h-4" />
          </button>
        )}
      </header>

      <main className="flex-1 pb-24">{children}</main>

      {user && !user.is_admin && (
        <nav className="fixed bottom-0 left-0 right-0 z-40 glass border-t border-white/5 safe-bottom">
          <div className="flex justify-around items-center h-16 max-w-md mx-auto">
            {nav.map(({ to, label, icon: Icon }) => {
              const active = location.pathname === to;
              return (
                <Link
                  key={to}
                  to={to}
                  data-testid={`nav-${to.slice(1) || 'home'}`}
                  className="flex flex-col items-center justify-center gap-1 px-3 py-1 transition-colors"
                >
                  <Icon
                    className={`w-5 h-5 transition-colors ${active ? 'text-[var(--gold)]' : 'text-white/50'}`}
                    strokeWidth={active ? 2.2 : 1.6}
                  />
                  <span className={`text-[10px] tracking-wide ${active ? 'text-[var(--gold)]' : 'text-white/50'}`}>{label}</span>
                </Link>
              );
            })}
          </div>
        </nav>
      )}
    </div>
  );
}
